import { ILoginError, ILoginForm } from "../../models/interfaces/interfaces";

export const LOGIN_FORM_INITIAL_VALUES: ILoginForm = {
  email: null,
  password: null,
  businessId: null,
  loungeId: null,
};

export const LOGIN_FORM_INITIAL_ERRORS: ILoginError = {
  email: null,
  password: null,
};
